import React, { useState } from 'react';
import { TextField } from 'material-ui';
import Check from 'material-ui/svg-icons/action/done';

/**
 * @param {{ 
 *      setEmailIdFilter: Function,
 *      currentEmailId: string,
 * }} SetEmailIdFilter
 */

export default function EmailIdInput({ setEmailIdFilter, currentEmailId }) {
    const [emailId, setEmailId] = useState(currentEmailId || '');

    const applyEmailId = (id) => {
        if (!id) {
            setEmailIdFilter('');
            return;
        }
        setEmailIdFilter(id.trim());
    };

    const modifyEmailId = (value) => {
        setEmailId(value);
        if (!value) {
            applyEmailId('');
        }
    };

    return (
        <div className='emailIdInput'>
            <Check
                className='emailIdInput--applier'
                style={{ cursor: emailId ? 'pointer' : 'auto' }}
                
                onClick={() => applyEmailId(emailId)}
                color={emailId ? 'black' : 'grey'}
            />
            <TextField
                className='emailIdInput--input'
                hintText='Email id'
                onChange={e => modifyEmailId(e.target.value)}
                value={emailId}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/EmailIdInput.jsx